var React = require('react');

function BoxPlus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.5","y":"1.5","width":"76","height":"76","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41.4582 37.5417H59.0832V41.4584H41.4582V59.0834H37.5415V41.4584H19.9165V37.5417H37.5415V19.9167H41.4582V37.5417Z","fill":"currentColor","key":1})]);
}

BoxPlus.defaultProps = {"width":"79","height":"79","viewBox":"0 0 79 79","fill":"none"};

module.exports = BoxPlus;

BoxPlus.default = BoxPlus;
